// extracted by mini-css-extract-plugin
export default {"block":"le","error":"me"};